import { ImageViewerContainer as L2RImageViewerContainer } from "@l2r-front/l2r-images"
import { MapWithSearchBar as L2RMap } from "@l2r-front/l2r-networks"
import { styledForMobile } from "@l2r-front/l2r-ui"

export const Map = styledForMobile(L2RMap, ["mapHeightPct"])(({ mapHeightPct }) => ({
    height: `${mapHeightPct}% !important`,
    display: mapHeightPct === 0 && "none",
}))

export const ImageViewerContainer = styledForMobile(L2RImageViewerContainer, ["mapHeightPct"])(({ mapHeightPct }) => ({
    height: `${100 - mapHeightPct}%`,
}))

export const MapWithPhotoViewerContainer = styledForMobile("div", ["fullScreenMode"])(({ fullScreenMode, theme }) => ({
    height: "100%",
    left: fullScreenMode ? 0 : "auto",
    position: fullScreenMode ? "fixed" : "relative",
    top: fullScreenMode ? 0 : "auto",
    width: "100%",
    zIndex: fullScreenMode ? theme.zIndex.drawer + 2 : "auto",
}))